// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__Ghv6X","div1":"Contact_div1__eHcq4","div2":"Contact_div2__6EQwj","div2left":"Contact_div2left__B0N39","div2right":"Contact_div2right__mHPTC"};